import React from 'react';
import { Link } from 'react-router-dom';
import Menu from './components/PageElements/Menu';
import Header from './components/PageElements/Header';
import './App.scss'

interface LayoutProps {
  className?: string;
  contentClassName?: string;
  children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ className = '', contentClassName = '', children }) => {
  return (
    <div className={`app-layout-css app ${className}`}>

      <Header />
      <div className='app-layout-css app-main '>
        <div className='app-widget shrink-0'>
          <Menu />
        </div>
        <div className={`app-content ${contentClassName} w-full h-full custom-page-css flex flex-col`}>
          {children}
        </div>
      </div>

    </div>
  );
}

export default Layout;
